import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystaonrentinmumbai() {



  const cardData =
  {
    keyword: 'Innova Crysta on Rent in Mumbai ',
    heading: 'Shambhu Cabs: Innova Crysta on Rent in Mumbai',
    headingDescription: 'Shambhu Cabs offers reliable Innova Crysta on Rent in Mumbai, providing safe, comfortable, and premium travel for families, corporate travelers, business executives, and groups heading across the city or on outstation trips. Our fleet of well-maintained Innova Crysta cars ensures a smooth and luxurious ride with spacious seating, ample luggage space, and modern amenities for a stress-free journey. With professional chauffeurs, flexible one-way and round-trip rental options, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes traveling in and around Mumbai convenient, safe, and enjoyable. For comfort, reliability, and a superior travel experience, Shambhu Cabs is your trusted choice for Innova Crysta rental in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch commemorating the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it stands as a historic entry point for British governors and a symbol of colonial-era architecture. Visitors enjoy ferry rides to Elephanta Island, street food stalls, coastal photography, and a lively promenade. Its illuminated evenings create a stunning waterfront ambiance that reflects the essence of Mumbai."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s famous 3.6 km-long coastline, known for its curved boulevard that glitters like a ‘Queen’s Necklace’ at night. The promenade is ideal for morning jogs, romantic walks, cycling, and enjoying refreshing sea breezes. The Art Deco buildings lining the stretch add heritage value, making it one of the world’s largest collections of Art Deco architecture. Sunsets here are especially mesmerizing, drawing locals, tourists, and photographers to soak in the city’s vibrant coastal charm."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is an architectural masterpiece blending Victorian Gothic Revival and Indian traditional designs. Built in 1887, it is one of India’s busiest railway stations and a symbol of Mumbai’s historic importance. Its grand domes, stained glass windows, carvings of flora and fauna, and intricate pillars make it a living museum. The nighttime lighting further enhances its majesty, making it a must-visit landmark for history, architecture, and photography enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its vibrant street food culture, local entertainers, and stunning sunsets. Visitors indulge in Mumbai’s iconic snacks like pav bhaji, bhel puri, and gola while enjoying camel rides, kite flying, and beach sports. The beach is also frequently visited by Bollywood celebrities who live in the surrounding areas. Its lively yet relaxed atmosphere makes it a perfect escape for families, couples, and tourists."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, believed to fulfill devotees’ wishes. The temple’s wooden doors depict Ashtavinayak carvings, and the gold-plated sanctum adds to its spiritual aura. Thousands queue up daily for darshan, including celebrities and leaders. During Ganesh Chaturthi, the entire area comes alive with devotional music, lights, and vibrant processions, showcasing Mumbai’s deep spiritual culture."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on an islet connected by a narrow causeway, is a stunning Indo-Islamic structure honoring Sufi saint Pir Haji Ali Shah Bukhari. Surrounded by the sea on all sides, it offers breathtaking views and a serene spiritual experience. The white marble structure, religious hymns, and peaceful setting attract visitors of all faiths. The walk to the dargah during low tide is a unique experience, blending spirituality with natural beauty."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site located on Elephanta Island, feature ancient rock-cut sculptures dedicated primarily to Lord Shiva. The 5th–8th century caves include magnificent carvings like the massive Trimurti (three-faced Shiva), Nataraja, and various mythological scenes. Visitors reach the island via ferry from the Gateway of India, experiencing a combination of history, art, nature, and coastal adventure."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel connecting Mumbai’s western suburbs to South Mumbai. Its cable-stayed architecture, sweeping curves, and views of the Arabian Sea make it a visual delight. The bridge significantly reduces travel time and symbolizes Mumbai’s urban growth. Sunrise, sunset, and nighttime views with illuminated cables provide spectacular photographic opportunities."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, one of India’s oldest and most famous flea markets, is renowned for antiques, vintage Bollywood memorabilia, gramophones, cameras, and rare collectibles. Walking through its busy lanes offers a glimpse into Mumbai’s historic trade culture. Bargain hunters, designers, and collectors explore the market to discover unique treasures. The chaotic yet vibrant atmosphere makes it an exciting spot for cultural enthusiasts and photographers."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park spans over 100 sq km in northern Mumbai, serving as a biodiversity hotspot and city escape. Visitors enjoy nature trails, lion and tiger safaris, boating, cycling, and trekking. The ancient Kanheri Caves within the park provide historical and archaeological interest. Home to leopards, monkeys, deer, and hundreds of bird species, it offers a jungle retreat in the middle of the city, perfect for adventure and nature enthusiasts."
  },
  {
    "title": "Mount Mary Church",
    "description": "The Basilica of Our Lady of the Mount, popularly called Mount Mary Church, is a Roman Catholic church atop a hill in Bandra. Known for its Gothic architecture, peaceful interiors, and panoramic views of the sea, it attracts devotees and tourists alike. The annual Bandra Fair in September draws large crowds for prayers, cultural programs, and local food. The church symbolizes Mumbai’s religious harmony and cultural diversity."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda in Gorai is a massive meditation hall and a monument to peace. Featuring the world’s largest stone dome built without supporting pillars, it serves as a center for learning Vipassana meditation. The pagoda’s serene atmosphere, golden interiors, and scenic gardens attract spiritual seekers and tourists. Visitors gain insight into India’s meditation traditions while enjoying panoramic views of the surrounding landscapes."
  }
],




"services": [
  {
    "name": "Crysta Rental Mumbai",
    "description": "Crysta Rental Mumbai offers premium Toyota Crysta cars for local, outstation, and airport travel. Perfect for families, groups, or corporate trips, the service ensures comfortable, spacious, and well-maintained vehicles with professional drivers and flexible booking options."
  },
  {
    "name": "Innova Crysta Taxi Mumbai",
    "description": "Innova Crysta Taxi Mumbai provides reliable taxi services with the luxurious and spacious Toyota Crysta. Ideal for city commutes, airport transfers, and outstation trips, it combines comfort, safety, and punctuality for a premium travel experience."
  },
  {
    "name": "Crysta Car Hire Mumbai",
    "description": "Crysta Car Hire Mumbai allows passengers to rent Toyota Crysta for hourly, daily, or long-distance travel. With professional chauffeurs and AC-equipped vehicles, it ensures smooth, comfortable, and stress-free transportation across Mumbai and nearby cities."
  },
  {
    "name": "Crysta Outstation Cab Mumbai",
    "description": "Crysta Outstation Cab Mumbai specializes in long-distance travel with Toyota Crysta. Spacious interiors, ample luggage space, and experienced drivers make it ideal for intercity trips, weekend getaways, and family journeys."
  },
  {
    "name": "Crysta Luxury Cab Mumbai",
    "description": "Crysta Luxury Cab Mumbai provides a premium travel experience with well-maintained Toyota Crysta cars. Ideal for corporate clients, weddings, and special occasions, the service offers professional drivers, comfort, and reliability."
  },
  {
    "name": "Crysta 7-Seater Cab Mumbai",
    "description": "Crysta 7-Seater Cab Mumbai is perfect for family outings, group travel, and corporate trips. With spacious seating, AC comfort, and professional drivers, it ensures a safe and convenient travel experience."
  },
  {
    "name": "Crysta Airport Taxi Mumbai",
    "description": "Crysta Airport Taxi Mumbai offers hassle-free airport transfers with Toyota Crysta. Timely pickups, comfortable interiors, and professional chauffeurs make your journey to and from Mumbai airports stress-free and convenient."
  },
  {
    "name": "Crysta Local Cab Mumbai",
    "description": "Crysta Local Cab Mumbai provides city rides with comfort and style. Whether for office commute, shopping, or personal errands, the service ensures timely pickups, AC comfort, and safe travel within Mumbai."
  },
  {
    "name": "Premium Crysta Rental",
    "description": "Premium Crysta Rental offers high-end Toyota Crysta vehicles for luxury travel within and outside Mumbai. Perfect for corporate trips, family outings, and long journeys, it guarantees comfort, safety, and excellent service."
  },
  {
    "name": "Affordable Crysta Hire Mumbai",
    "description": "Affordable Crysta Hire Mumbai provides budget-friendly rental options for Toyota Crysta without compromising on quality, comfort, or safety. Ideal for local rides, airport transfers, and outstation trips."
  },
  {
    "name": "Crysta Driver Service Mumbai",
    "description": "Crysta Driver Service Mumbai offers professional chauffeur-driven Toyota Crysta vehicles for city or long-distance travel. The service ensures punctuality, safety, and convenience for every trip."
  },
  {
    "name": "Crysta Corporate Cab",
    "description": "Crysta Corporate Cab provides reliable and comfortable transportation solutions for corporate employees, clients, and business trips. Equipped with professional drivers and spacious interiors, it ensures seamless corporate travel."
  },
  {
    "name": "Crysta AC Taxi Mumbai",
    "description": "Crysta AC Taxi Mumbai offers fully air-conditioned rides in Toyota Crysta for city and intercity travel. Passengers enjoy a comfortable, smooth, and safe journey with professional drivers."
  },
  {
    "name": "Crysta Tourist Cab Mumbai",
    "description": "Crysta Tourist Cab Mumbai provides services for sightseeing, leisure trips, and city tours. Spacious seating, AC comfort, and experienced drivers make it ideal for family and group travel."
  },
  {
    "name": "Crysta Long Distance Cab",
    "description": "Crysta Long Distance Cab specializes in intercity travel and long-distance trips. Comfortable interiors, ample luggage space, and professional drivers ensure a safe and pleasant journey over extended distances."
  },
  {
    "name": "Book Crysta Mumbai",
    "description": "Book Crysta Mumbai allows quick and easy online booking for Toyota Crysta cabs. With instant confirmation, professional drivers, and flexible travel options, it ensures a seamless and hassle-free experience."
  },
  {
    "name": "Toyota Crysta Rental Mumbai",
    "description": "Toyota Crysta Rental Mumbai offers premium 7-seater vehicles for city rides, airport transfers, corporate travel, and long-distance trips. Professional drivers, AC comfort, and well-maintained cars make every ride luxurious and safe."
  }
],

"tableData": [
  ["Crysta Rental Mumbai", "Innova Crysta Taxi Mumbai"],
  ["Crysta Car Hire Mumbai", "Crysta Outstation Cab Mumbai"],
  ["Crysta Luxury Cab Mumbai", "Crysta 7-Seater Cab Mumbai"],
  ["Crysta Airport Taxi Mumbai", "Crysta Local Cab Mumbai"],
  ["Premium Crysta Rental", "Affordable Crysta Hire Mumbai"],
  ["Crysta Driver Service Mumbai", "Crysta Corporate Cab"],
  ["Crysta AC Taxi Mumbai", "Crysta Tourist Cab Mumbai"],
  ["Crysta Long Distance Cab", "Book Crysta Mumbai"],
  ["Toyota Crysta Rental Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta on Rent in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers Innova Crysta on rent in Mumbai, ideal for family trips, business travel, airport transfers, and luxurious city or outstation rides."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Innova Crysta",
    "WhyChoosedescription": "Travel in a clean, air-conditioned, and regularly serviced Innova Crysta to enjoy a smooth, comfortable, and premium ride in Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Timely Travel",
    "WhyChoosedescription": "Our professional drivers are familiar with Mumbai routes, ensuring punctual, safe, and hassle-free journeys in an Innova Crysta."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear, upfront pricing—fuel, tolls, and driver allowances included—making your Innova Crysta rental stress-free and budget-friendly."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your Innova Crysta travel needs in Mumbai."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Innova Crysta cars are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Innova Crysta rental in Mumbai convenient and worry-free."
  }
]















  }

const faqData = [
  {
    question: 'Can I rent an Innova Crysta in Mumbai with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs provides Innova Crysta on rent in Mumbai for premium and comfortable travel, including local rides, airport transfers, and outstation trips.',
  },
  {
    question: 'How can I book an Innova Crysta on rent in Mumbai?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for a quick and hassle-free booking.',
  },
  {
    question: 'Is Innova Crysta suitable for family or group travel in Mumbai?',
    answer: 'Absolutely. The Innova Crysta is ideal for families and groups, offering spacious seating, comfort, and a smooth ride for city and outstation journeys.',
  },
  {
    question: 'Are drivers experienced for Innova Crysta rentals in Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and well-acquainted with Mumbai routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for Innova Crysta rental?',
    answer: 'Yes, you can select any pickup and drop-off points within Mumbai or for outstation trips according to your convenience.',
  },
  {
    question: 'Is Innova Crysta rental available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock Innova Crysta rental services to accommodate any travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Innova Crysta rentals?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict hygiene and safety measures to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available for Innova Crysta rental in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for Innova Crysta bookings.',
  },
  {
    question: 'Is customer support available during Innova Crysta rental trips in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Innova Crysta rental journey in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    feedback: 'Renting an Innova Crysta from Shambhu Cabs in Mumbai was a premium and comfortable experience. Spacious seats and smooth ride made our trip enjoyable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Rao',
    feedback: 'Highly satisfied with Shambhu Cabs’ Innova Crysta rental service in Mumbai. Professional drivers and excellent service throughout the journey.',
    rating: 5,
  },
];






























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta Rental in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/innova-crysta-rental-mumbai.jpg",
  "description": "Shambhu Cabs offers premium Innova Crysta car rentals in Mumbai. Ideal for local rides, airport transfers, corporate travel, family trips, and long-distance journeys. Book reliable 7-seater Crysta taxis with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/innova-crysta-rental-mumbai"
  }
};






  return (
    <div>
<Helmet>
  <title>Innova Crysta Rental in Mumbai | 7-Seater Taxi, Airport & Outstation | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Innova Crysta rental in Mumbai with Shambhu Cabs. Premium 7-seater for local rides, airport transfers, family trips, corporate travel, and long-distance journeys. Reliable Crysta taxis with professional drivers."
  />

  <meta
    name="keywords"
    content="Crysta Rental Mumbai, Innova Crysta Taxi Mumbai, Crysta Car Hire Mumbai, Crysta Outstation Cab Mumbai, Crysta Luxury Cab Mumbai, Crysta 7-Seater Cab Mumbai, Crysta Airport Taxi Mumbai, Crysta Local Cab Mumbai, Premium Crysta Rental, Affordable Crysta Hire Mumbai, Crysta Driver Service Mumbai, Crysta Corporate Cab, Crysta AC Taxi Mumbai, Crysta Tourist Cab Mumbai, Crysta Long Distance Cab, Book Crysta Mumbai, Toyota Crysta Rental Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaonrentinmumbai;